import { TimeLineWeek } from './time-line-week';

export class TimeLineMonth {

    id: number;
    date: Date;
    lastDate: Date;
    hasDays: Boolean;

    weeks: TimeLineWeek[]; 
}